import React from 'react';
import { ScheduleCellProps } from './types';
import { formatScheduleDateTime } from '../DeliveryDaysExpand';

const EndDateCell = ({ row, timezone }: ScheduleCellProps) => {
  const endTime = row?.original?.end_time;

  if (!endTime) {
    return null;
  }
  return <>{formatScheduleDateTime(endTime, timezone)}</>;
};

export default EndDateCell;
